import _get from 'lodash/get'
import { parseDate } from '@/utilities/Date/parse'
import Actions from '../../../components/Actions'
import Details from '../../../components/Details'

export const updateRows = function({ table, list }) {
  const dateFormat = 'LL'

  console.debug('table=' + table)

  console.debug('list=' + JSON.stringify(list))

  this.rows = list.map(unitGroup => {
    console.debug('table rows=' + JSON.stringify(unitGroup))

    const id = _get(unitGroup, 'unitGroupID', '')
    const name = _get(unitGroup, 'name', '')
    const unitGroupUnits = _get(unitGroup, 'unitGroupUnits', null)

    const parsed = {
      _expandable: {
        show: true,
        expanded: true,
        component: Details,
        props: {
          unitGroupID: id,
          unitGroupUnits,
          loadUpdateUnitGroupUnit: (_id, _name) => {
            this.loadUpdateUnitGroupUnit(_id, _name)
          },
          confirmDeleteUnitGroupUnit: (_id, _name) => {
            this.confirmDeleteUnitGroupUnit(_id, _name)
          },
          addUnitGroupUnit: () => {
            this.openUnitGroupUnitModal({
              unitGroupID: id,
              action: 'addunitgroupunit'
            })
          }
        }
      },

      id,
      name,
      modifiedDate: {
        date: parseDate(_get(unitGroup, 'modifiedDate', ''), dateFormat),
        format: dateFormat
      },
      actions: {
        component: Actions,
        props: {
          unitGroupID: id,
          loadUnitGroupUnit: _id => {
            this.openUnitGroupUnitModal({
              unitGroupUnitID: _id,
              action: 'add'
            })
          },
          loadUpdateUnitGroup: _id => {
            this.updateSelected({
              id: _id,
              list
            })

            this.loadUpdateUnitGroup(_id)
          },
          confirmDeleteUnitGroup: (_id, name) => {
            console.debug('name=' + name || '')
            this.confirmDeleteUnitGroup(_id, _get(unitGroup, 'name', ''))
          }
        }
      }
    }

    return parsed
  })
}
